import { Injectable, signal, effect, untracked } from '@angular/core';
import { NavController } from '@ionic/angular';
import { PlatformService } from '../platform/platform.service';
import { Logger, LoggingService } from 'ionic-logging-service';

@Injectable({
  providedIn: 'root'
})
export class AuthSignalService {
  public unauthenticatedSignal = signal(false);
  private logger: Logger;
  private isHandlingUnauthenticated = false;

  constructor(
    private navController: NavController,
    private platformService: PlatformService,
    private loggingService: LoggingService
  ) {
    this.logger = this.loggingService.getLogger("[AuthSignalService]");

    // Watch for unauthenticated signal and handle navigation
    effect(() => {
      if (this.unauthenticatedSignal() && !this.isHandlingUnauthenticated) {
        this.handleUnauthenticatedUser();
      }
    });
  }

  public triggerUnauthenticated(): void {
    this.logger.info('triggerUnauthenticated() - User needs to be redirected to sign-in');
    if (!this.isHandlingUnauthenticated) {
      this.unauthenticatedSignal.set(true);
    }
  }

  private handleUnauthenticatedUser(): void {
    this.logger.info('handleUnauthenticatedUser() - Navigating to sign-in');

    // Prevent re-entry
    this.isHandlingUnauthenticated = true;

    // Reset the signal outside of the reactive context to prevent loops
    untracked(() => {
      this.unauthenticatedSignal.set(false);
    });

    // Navigate to appropriate page based on platform
    const isCordova = this.platformService.isCordova();
    const queryParams = { signOutParam: 'ACCESS_DENIED' };
    const path = isCordova ? '/sign-in' : '/network-check';

    this.navController.navigateRoot([path], { queryParams }).then(() => {
      // Reset the flag after navigation completes
      this.isHandlingUnauthenticated = false;
    }).catch((error) => {
      this.logger.error('Navigation error:', error);
      this.isHandlingUnauthenticated = false;
    });
  }
}